// ─── The tile picker's shape: dashboards grouped by the EVENT they belong to ──
// A client's tile catalogue is entity-wide, so the picker was one flat run of
// every dashboard across every event — fine for a one-event client, a scroll
// through forty near-identical rows for a promoter with four. Grouping by suite
// (the event) turns it into a short list of events you open one at a time,
// which is also the only version of it that works on a phone.
//
// Rules that matter:
//   • the server's order is kept (suites are already in the client's own order),
//   • a dashboard bundled into two SETS of the same event is one row, not two
//     (it is the same dashboard, and duplicate rows read as a data error),
//   • a dashboard genuinely attached to two EVENTS appears under both — that is
//     a real fact about it, and each branch is its own pick,
//   • anything with no event (shouldn't happen, but never drop a selectable
//     dashboard on the floor) lands in one clearly-named catch-all group.
//
// Pure functions, no React: the picker renders them, and they can be reasoned
// about (and tested) without a DOM.

export const OTHER_GROUP = 'Other dashboards';

// [{ dashboardId, title, setName, suiteId, suiteName, direct?, tiles }]
//   → [{ key, name, dashboards: [...] }] in catalogue order.
export function groupBySuite(dashboards = []) {
  const groups = [];
  const byKey = new Map();
  for (const d of dashboards || []) {
    if (!d || !d.dashboardId) continue;
    const name = d.suiteName || OTHER_GROUP;
    const key = d.suiteId || `name:${name}`;
    let g = byKey.get(key);
    if (!g) { g = { key, name, dashboards: [] }; byKey.set(key, g); groups.push(g); }
    if (!g.dashboards.some((x) => x.dashboardId === d.dashboardId)) g.dashboards.push(d);
  }
  return groups;
}

// What a dashboard row shows under its title: the set it came from, or — for a
// dashboard linked STRAIGHT to the event with no set behind it — that fact.
export function sourceLabel(d) {
  return d?.direct ? 'Linked to this event' : (d?.setName || '');
}
